<div
  class="ds-modal-container"
  [ngClass]="{ 'component-mode': !isDialogMode }"
  [class.inner-component]="modalData.innerComponent"
>
  <div class="header">
    <div class="title-container" [ngClass]="{ 'justify-content-end': !modalData.title && !modalData.titleDsIcon }">
      <div class="title-wrapper" *ngIf="modalData.title || modalData.titleDsIcon">
        <ds-icon
          *ngIf="modalData.titleDsIcon"
          class="title-icon"
          [icon]="modalData.titleDsIcon"
          width="32px"
          height="32px"
          type="info"
          [addBackground]="true"
        ></ds-icon>
        <span *ngIf="modalData.title" class="title">{{ modalData.title }}</span>
      </div>
      <ds-icon icon="cross" class="close-icon" (click)="close()"></ds-icon>
    </div>

    <span
      *ngIf="modalData.description && modalData.descriptionHtml"
      class="description"
      [innerHTML]="modalData.description"
    ></span>
    <span *ngIf="modalData.description && !modalData.descriptionHtml" class="description">{{ modalData.description }}</span>
  </div>

  <div class="dialog-content" *ngIf="modalData.innerComponent">
    <div class="content-wrapper">
      <ng-container>
        <ng-container *ngComponentOutlet="modalData.innerComponent; injector: childInjector"></ng-container>
      </ng-container>
    </div>
  </div>

  <div class="footer d-none d-md-flex d-lg-flex footer-desktop" *ngIf="modalData.submitLabel || modalData.cancelLabel">
    <div class="btn-wrapper">
      <ds-button
        *ngIf="modalData.cancelLabel"
        class="d-flex"
        color="secondary"
        size="lg"
        width="fixed"
        fixedWidth="100%"
        (click)="onClose()"
        [label]="modalData.cancelLabel"
        [state]="modalData.stateCancel"
        [disabled]="modalData.disabledCancel"
        [loading]="modalData.loadingCancel"
        [loadingText]="modalData.loadingTextCancel"
        [dsIcon]="modalData.cancelDsIcon"
      ></ds-button>
      <ds-button
        *ngIf="modalData.submitLabel"
        class="d-flex"
        color="primary"
        size="lg"
        width="fixed"
        fixedWidth="100%"
        (click)="submit()"
        [label]="modalData.submitLabel"
        [state]="modalData.stateSubmit"
        [disabled]="modalData.disabledSubmit"
        [loading]="modalData.loadingSubmit"
        [loadingText]="modalData.loadingTextSubmit"
        [dsIcon]="modalData.submitDsIcon"
      ></ds-button>
    </div>
  </div>

  <div class="footer d-flex d-md-none d-lg-none footer-mobile" *ngIf="modalData.submitLabel || modalData.cancelLabel">
    <div class="btn-wrapper">
      <ds-button
        *ngIf="modalData.submitLabel"
        class="d-flex"
        color="primary"
        size="md"
        width="fixed"
        fixedWidth="100%"
        (click)="submit()"
        [label]="modalData.submitLabel"
        [state]="modalData.stateSubmit"
        [disabled]="modalData.disabledSubmit"
        [loading]="modalData.loadingSubmit"
        [loadingText]="modalData.loadingTextSubmit"
        [dsIcon]="modalData.submitDsIcon"
      ></ds-button>
      <ds-button
        *ngIf="modalData.cancelLabel"
        class="d-flex"
        color="secondary"
        size="md"
        width="fixed"
        fixedWidth="100%"
        (click)="onClose()"
        [label]="modalData.cancelLabel"
        [state]="modalData.stateCancel"
        [disabled]="modalData.disabledCancel"
        [loading]="modalData.loadingCancel"
        [loadingText]="modalData.loadingTextCancel"
        [dsIcon]="modalData.cancelDsIcon"
      ></ds-button>
    </div>
  </div>
</div>
